// extracted by mini-css-extract-plugin
export default {"inputLabel":"CqZb8iL2edwNZzpzd7pJ"};